import { buildAuthDownloadUrl } from '@/shared/api'

/**
 * Download a file from an API path with authentication.
 * Uses Telegram WebApp.downloadFile() if available, otherwise falls back
 * to opening the authenticated URL directly.
 */
export function downloadAuthFile(apiPath: string, fileName: string): void {
  const url = buildAuthDownloadUrl(apiPath)
  const tg = window.Telegram?.WebApp

  // Telegram WebApp 6.4+ has downloadFile
  if (tg && typeof tg.downloadFile === 'function') {
    tg.downloadFile({ url, file_name: fileName })
    return
  }

  // Fallback: open link via Telegram (handles external URLs better than window.open)
  if (tg && typeof tg.openLink === 'function') {
    tg.openLink(url)
    return
  }

  // Last resort: plain browser navigation
  window.open(url, '_blank')
}
